import { CONTACT } from "../lib/constants";
import { WhatsappLogo, Phone } from "@phosphor-icons/react";

export default function FloatingActions() {
  return (
    <div className="fixed bottom-6 left-6 z-40 flex flex-col gap-3">
      <a
        href={`https://wa.me/${CONTACT.whatsapp}?text=Hi%20Gurdeep%2C%20I%27d%20like%20a%20quote`}
        target="_blank"
        rel="noreferrer"
        data-testid="float-whatsapp"
        className="bg-[#25D366] text-white border-2 border-[#111] shadow-brut-sm p-3 hover:translate-x-[-3px] hover:translate-y-[-3px] hover:shadow-brut transition-transform"
        aria-label="WhatsApp"
      >
        <WhatsappLogo size={24} weight="fill" />
      </a>
      <a
        href={`tel:${CONTACT.phone}`}
        data-testid="float-call"
        className="bg-[#D85C3A] text-white border-2 border-[#111] shadow-brut-sm p-3 hover:translate-x-[-3px] hover:translate-y-[-3px] hover:shadow-brut transition-transform"
        aria-label="Call"
      >
        <Phone size={24} weight="fill" />
      </a>
    </div>
  );
}
